import { Component, OnInit, OnDestroy } from '@angular/core';
import { Subscription } from 'rxjs';
import { delay } from 'rxjs/operators';
import Swal from 'sweetalert2';

import { EmpleadoService } from '../../../services/empleado.service';
import { ModalImagenService } from '../../../services/modal-imagen.service';
import { BusquedasService } from '../../../services/busquedas.service';
import { EmployeeModel } from '../../../models/employee.model';



@Component({
    selector: 'app-empleados',
    templateUrl: './empleados.component.html',
    styles: [],
    standalone: false
})
export class EmpleadosComponent implements OnInit, OnDestroy {


public empleado: EmployeeModel[] = [];
public empleadoTemp: EmployeeModel[] = [];
public cargando: boolean = true;

private imgSubs: Subscription;


page = 1;
pageSize = 10;
collectionSize = 0;
maxSize = 0;



  constructor( private empleadosService: EmpleadoService,
               private busquedaService: BusquedasService,
               private modalImagenService: ModalImagenService) { }



  ngOnDestroy(): void {
     this.imgSubs.unsubscribe();
  }

  ngOnInit(): void {


    this.cargarEmpleados();

    this.imgSubs = this.modalImagenService.nuevaImagen
                                .pipe(delay(100))
                                .subscribe( img => this.cargarEmpleados() );



  }


cargarEmpleados() {


  this.cargando = true;

  this.empleadosService.cargarEmpleados()
                      .subscribe( employees => {

                        console.log(employees);


                        this.cargando = false;

                        this.empleadoTemp = employees;
                        this.empleado = this.empleadoTemp.slice(0, this.pageSize);
                        this.maxSize = Math.ceil(this.empleadoTemp.length / this.pageSize);
                        this.collectionSize = this.empleadoTemp.length;

                      });


}

buscar( termino: string) {

    if ( termino.length === 0 ){
      return this.empleado = this.empleadoTemp;
    }



    this.busquedaService.buscar( 'employees', termino )
                        .subscribe( (resp: any) => {
                          this.empleado = resp;
                        });


}



borrarEmpleado( empleado: EmployeeModel ) {

  Swal.fire({
    title: 'Delete',
    text: `Delete ${ empleado.name }`,
    icon: 'question',
    showCancelButton: true,
    confirmButtonText: 'Yes, Deleted'
  }).then((result) => {
    if (result.value) {

      this.empleadosService.borrarEmpleado( empleado._id )
      .subscribe( resp => {

        this.cargarEmpleados();

        Swal.fire(
          'Deleted',
          `${ empleado.name }`,
          'success'
        );


      });

    }
  });


}

abrirModal( empleado: EmployeeModel ) {
  this.modalImagenService.abrirModal( 'employees', empleado._id, empleado.img );
}


refresData() {
  this.empleado = this.empleadoTemp.slice((this.page - 1) * this.pageSize, (this.page - 1) * this.pageSize + this.pageSize);
}


}
